import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import { isEcrOpsWriteRole } from "components/RequirePermission/RequireEcrOpsRole";
import UnauthorizedAccess from "components/RequirePermission/UnauthorizedAccess";
import { useCurrentUserRoleNames } from "components/RequirePermission/useAccessPermissions";

// Sync Operations is for the ECR Ops admin roles (Enterprise Admin and Operations Admin) — not Operations User. It runs
// actions that change data across organizations. The backend still checks its own permissions on every call.
// null while the roles are still loading.
export const useCanUseSync = () => {
  const roleNames = useCurrentUserRoleNames();
  if (roleNames === null || roleNames === undefined) return null;
  return isEcrOpsWriteRole(roleNames);
};

// Wraps the Sync Operations route, so the address can't be typed in by anyone else.
export const RequireSyncAccess = () => {
  const allowed = useCanUseSync();
  if (allowed === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", padding: "4rem" }}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  if (!allowed) return <UnauthorizedAccess message="Sync Operations is limited to Enterprise Admins and Operations Admins." />;
  return <Outlet />;
};
